import React, { useEffect, useState } from 'react'
import { store } from '../../../redux/store';
import { Button, Input, Modal, Table, ConfigProvider, notification, Radio, Switch, Avatar, List, Space, Tabs, InputNumber } from 'antd';
import { PlusOutlined, DeleteOutlined, LikeOutlined, MessageOutlined, StarOutlined, RetweetOutlined, SwapLeftOutlined, SwapRightOutlined, AndroidOutlined, AppleOutlined } from '@ant-design/icons';
import zhCN from 'antd/es/locale/zh_CN';
import Serach from '../../generalComponent/search';
import { useNavigate } from 'react-router-dom';
import './index.css';
//引入axios 进行服务器接口请求
import axios from "axios";
export default function Basket() {
  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, title, msg) => {
    api[type]({
      message: title,
      description: msg,
      placement: 'top',
      duration: 1
    });
  };
  const [dataMap, setDataMap] = useState({});//数据map
  const [open, setOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [activeKey, setActiveKey] = useState(1);
  let navigate = useNavigate();
  const [data, setData] = useState([]);
  const [packData, setPackData] = useState([]);
  const [packDes, setPackDes] = useState();
  const [packNumMap, setPackNumMap] = useState(new Map());//数据map
  const [pushType, setPushType] = useState();//1押入 2 押出
  const [customerId, setCustomerId] = useState();
  useEffect(() => {
    queryBasketList(1);
  }, []); // 空数组确保只在挂载时设置观察者

  const token = store.getState().uData.token;
  function queryBasketList(key) {
    //请求后台接口
    // / 设置全局的Authorization头
    axios.defaults.headers.common['token'] = token;
    const params = new URLSearchParams();
    params.append('ilk', key);
    axios.post('/api/basket/queryBasketList',
      params,
    ).then(
      response => {
        if (response.data.code === "200") {
          setData(response.data.data);
        } else {
          setData({});
        }
      },
      error => {
        navigate("/error");
      }
    )
  }

  const onChange = key => {
    setActiveKey(key);
    queryBasketList(key);
  };

  const entryAndExitRecord = (id) => {
     navigate("/main/baskethistory?customerId=" + id+"&activeKey="+activeKey)
    setModalTitle("筐子押入押出记录");
    setOpen(true);
  };
  const pushIn = (item) => {
    setPushType(1);
    setCustomerId(item.customerId);
    setPackData(item.packInfos);
    setPackDes(item.packDes);
    setPackNumMap(item.packNumMap);
    setModalTitle("押入筐子");
    setOpen(true);
  };
  const pushOut = (item) => {
    setPushType(2);
    setCustomerId(item.customerId);
    setPackData(item.packInfos);
    setPackDes(item.packDes);
    setPackNumMap(item.packNumMap);
    setModalTitle("押出筐子");
    setOpen(true);
  };

  const handleOk = () => {
    inOrOut();
  };


  function inOrOut() {
    // / 设置全局的Authorization头
    let basketArr = [];
    for (const key in dataMap) {
      if (dataMap.hasOwnProperty(key)) { // 确保是对象自身的属性，避免原型链上的属性
        basketArr.push(
          { "id": key, "value": dataMap[key] }
        )
      }
    }

    const objData = {
      "customerId": customerId,
      "activeKey": activeKey,
      "pushType": pushType,
      "basketData": basketArr
    }
    axios.defaults.headers.common['token'] = token;
    axios.post('/api/basket/inOrOut',
      JSON.stringify(objData),
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    ).then(
      response => {
        if (response.data.code === "200") {
          setDataMap({});
          setCustomerId({});
          setOpen(false);
          openNotificationWithIcon('success', '消息提示', "提交成功!")
          queryBasketList(activeKey);
        } else {
          openNotificationWithIcon('error', '消息提示', '筐子出入库失败！')
        }

      },
      error => {
        navigate("/error");
      }
    )
  }





  const handleCancel = () => {
    //清空数据
    setDataMap({});
    setCustomerId({});
    setOpen(false);
  };

  const handlePackNumChange = (id, value) => {
    setDataMap({
      ...dataMap,
      [id]: value
    }
    );
  };

  return (
    <React.Fragment>
      {contextHolder}
      <div className="item-location">
        当前所在位置 : 筐子进出管理
      </div>
      <div className="data-div">
        <Tabs
          defaultActiveKey="1"
          onChange={onChange}
          items={[AppleOutlined, AndroidOutlined].map((Icon, i) => {
            const id = String(i + 1);
            const tabTitle = ["销售", "购买"]
            return {
              key: id,
              label: `${tabTitle[i]}`,
              icon: <Icon />,
            };
          })}
        />
        <List
          itemLayout="vertical"
          size="large"
          pagination={{
            pageSize: 5,
            align: 'center',
            hideOnSinglePage: 'true'
          }}
          dataSource={data}
          renderItem={item => (
            <List.Item
              extra={
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                  <Button className="bt_come_go" onClick={() => entryAndExitRecord(item.customerId)}><RetweetOutlined />来往记录</Button>
                  <Button className="bt_push_in" style={(activeKey == 1 && item.allPackNum === 0) ? { pointerEvents: 'none', opacity: '0.5', backgroundColor: '#2F4F4F' } : {}} onClick={() => pushIn(item)}><SwapRightOutlined />押入</Button>
                  <Button className="bt_extrusion" style={(activeKey == 2 && item.allPackNum === 0) ? { pointerEvents: 'none', opacity: '0.5', backgroundColor: '#2F4F4F' } : {}} onClick={() => pushOut(item)}><SwapLeftOutlined />押出</Button>
                </div>
              }
            >
              <List.Item.Meta
                title={item.customerName}
              />
              <div className="_des">
                {item.packDes}
              </div>
              <div className="_des">
                {item.money}
              </div>
            </List.Item>
          )}
        />
      </div>

      <Modal
        open={open}
        title={modalTitle}
        onOk={handleOk}
        onCancel={handleCancel}
        width={600}
        centered={true}
        cancelText="取消"
        okText="确定"
        maskClosable={false}
      >
        <div className='pack_content'>
          <div className='pack_des'><span>{packDes}</span></div>
          {
            packData.map((item, index) => (
              <div className='pack_items'>
                <div className='pack_name'><span style={{ marginRight: '5px' }}>名称:</span><span>{item.name}</span></div>
                <div className='pack_num'>
                  <span style={{ marginRight: '5px' }}>数量:</span><InputNumber style={{ width: '90%' }} min={0} max={activeKey == 1 ? (pushType == 1 ? packNumMap[item.id] : 1000000) : (pushType == 1 ? 1000000 : packNumMap[item.id])} formatter={value => `${value}`.replace(/\D/g, '')} parser={value => value.replace(/\D/g, '')} value={dataMap[item.id]} changeOnWheel onChange={(value) => handlePackNumChange(item.id, value)} />
                </div>
              </div>

            ))
          }
        </div>
      </Modal>
    </React.Fragment>

  )
}
